import { Icon } from '@trussworks/react-uswds';

export const USWDSIcon = Icon;
